import { takeEvery, put, apply } from 'redux-saga/effects';
import { call, select, all } from 'typed-redux-saga';
import { GoogleTagManagerEvent } from 'constants/google';
import { createPhoto, getPhotos } from 'data/api';
import { transformMediaUploadPhotoDtos, transformMediaUploadPhotoDto } from 'data/transformers/media-upload-photo';
import { tracker } from 'libs/common/tracker';
import { userEditPhotoEvent } from 'libs/common/event-tracker/events';
import { googleTagManagerTrack } from 'data/utils/google';
import * as sessionSelectors from 'state/session/selectors';
import { actions } from './slice';
import { createPhotoFormData } from './utils';
import { getPhotosCount, getPhotoIds } from './selectors';
export function* submitEditedPhoto(_ref) {
  let {
    payload
  } = _ref;

  try {
    const convertedPhoto = createPhotoFormData(new File([payload.image], 'imgly'), payload.type, payload.tempUuid);
    const response = yield call(createPhoto, convertedPhoto);

    if ('errors' in response) {
      yield put(actions.submitEditedPhotoFailure());
      return;
    }

    const transformedPhoto = yield* call(transformMediaUploadPhotoDto, response);
    yield put(actions.updateExistingPhoto({
      photo: transformedPhoto,
      imageToReplaceId: payload.id
    }));
    const currentIds = yield* select(getPhotoIds);
    yield put(actions.submitEditedPhotoSuccess({
      currentIds
    }));
    const photoEditEvent = userEditPhotoEvent({
      tempUuid: transformedPhoto.tempUuid,
      photoId: "".concat(payload.id, ", ").concat(transformedPhoto.id)
    });
    yield apply(tracker, tracker.track, [photoEditEvent]);
  } catch (error) {
    yield put(actions.submitEditedPhotoFailure());
  }
}
export function* uploadPhotoFiles(_ref2) {
  let {
    payload
  } = _ref2;
  const {
    tempUuid,
    type,
    files
  } = payload;

  try {
    const convertedPhotos = files.map(file => createPhotoFormData(file, type, tempUuid));
    const responses = yield* all(convertedPhotos.map(photo => call(createPhoto, photo)));
    const photoResponses = responses.filter(response => !('errors' in response));
    const hasError = responses.reduce((previous, response) => previous || 'errors' in response, false);

    if (hasError) {
      yield put(actions.uploadPhotoFailure());
      return;
    }

    const transformedPhotos = yield* call(transformMediaUploadPhotoDtos, photoResponses);
    yield put(actions.uploadPhotoSuccess({
      photos: transformedPhotos
    }));
    const count = yield* select(getPhotosCount);
    const itemCount = yield* select(sessionSelectors.getUserItemCount);
    googleTagManagerTrack(GoogleTagManagerEvent.PhotoUpload, {
      photo_count: count,
      occurrence_number: itemCount + 1
    });
  } catch (error) {
    yield put(actions.uploadPhotoFailure());
  }
}
export function* fetchPhotosRequest(_ref3) {
  let {
    payload
  } = _ref3;
  const {
    type,
    photoEntryId,
    tempUuid
  } = payload;
  const response = yield* call(getPhotos, {
    type,
    photoEntryId,
    tempUuid
  });

  if ('errors' in response) {
    yield put(actions.fetchPhotosFailure());
    return;
  }

  const transformedPhotos = yield* call(transformMediaUploadPhotoDtos, response.photos_dto);
  yield put(actions.fetchPhotosSuccess({
    photos: transformedPhotos
  }));
}
export default function* saga() {
  yield takeEvery(actions.uploadPhotoFiles, uploadPhotoFiles);
  yield takeEvery(actions.fetchPhotosRequest, fetchPhotosRequest);
  yield takeEvery(actions.submitEditedPhoto, submitEditedPhoto);
}